import React, { useState } from 'react';
import { XIcon, LoaderIcon } from 'lucide-react';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
interface RegistrationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}
export function RegistrationModal({
  isOpen,
  onClose,
  onSuccess
}: RegistrationModalProps) {
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    email: '',
    phone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  if (!isOpen) return null;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // Validate that phone number has country code (starts with +)
    if (!formData.phone || !formData.phone.startsWith('+')) {
      setError('Por favor, selecciona un código de país para tu teléfono.');
      return;
    }
    setIsSubmitting(true);
    try {
      await axios.post('https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/Bk0RG51jGGQNZvWm8eSs', {
        nombreCompleto: formData.nombreCompleto,
        email: formData.email,
        phone: formData.phone
      });
      onSuccess();
    } catch (err) {
      setError('Hubo un error al enviar el formulario. Por favor, intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handlePhoneChange = (value: string | undefined) => {
    setFormData({
      ...formData,
      phone: value || ''
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[100] p-4 overflow-y-auto" data-id="element-195">
      <div className="bg-gray-900 rounded-lg max-w-md w-full relative z-[101] my-8" data-id="element-196">
        <div className="bg-gray-900 border-b border-gray-700 p-4 md:p-6 flex justify-between items-center rounded-t-lg" data-id="element-197">
          <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-198">
            Reserva Tu Lugar
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-2 -mr-2 touch-manipulation" aria-label="Close" disabled={isSubmitting} data-id="element-199">
            <XIcon className="h-6 w-6" data-id="element-200" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4" data-id="element-201">
          <div data-id="element-202">
            <label htmlFor="nombreCompleto" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-203">
              Nombre Completo *
            </label>
            <input type="text" id="nombreCompleto" name="nombreCompleto" value={formData.nombreCompleto} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-base focus:outline-none focus:border-red-500 touch-manipulation" disabled={isSubmitting} data-id="element-204" />
          </div>
          <div data-id="element-205">
            <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-206">
              Email *
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-base focus:outline-none focus:border-red-500 touch-manipulation" disabled={isSubmitting} data-id="element-207" />
          </div>
          <div data-id="element-208">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-209">
              Teléfono (con código de país) *
            </label>
            <PhoneInput international defaultCountry="US" value={formData.phone} onChange={handlePhoneChange} disabled={isSubmitting} className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-base focus:outline-none focus:border-red-500 touch-manipulation [&_input]:bg-gray-800 [&_input]:text-white [&_input]:border-0 [&_.PhoneInputCountry]:bg-gray-800 [&_.PhoneInputCountrySelect]:bg-gray-800 [&_.PhoneInputCountrySelect]:text-white" required data-id="element-210" />
          </div>
          {error && <div className="text-red-500 text-sm bg-red-500 bg-opacity-10 border border-red-500 rounded-lg p-3" data-id="element-211">
              {error}
            </div>}
          <button type="submit" disabled={isSubmitting} className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-bold py-4 px-6 shadow-lg transform hover:scale-105 active:scale-95 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center touch-manipulation" data-id="element-212">
            {isSubmitting ? <>
                <LoaderIcon className="h-5 w-5 mr-2 animate-spin" data-id="element-213" />
                Enviando...
              </> : 'RESERVAR MI LUGAR'}
          </button>
        </form>
      </div>
    </div>;
}